import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EMPTY, expand, Observable, reduce } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminResDto } from '../_dtos/adminResDto';
import { CatalogResDto } from '../_dtos/catalogResDto';


export interface FilterParams {
  from?: string;
  to?: string;
  component?: string;
  entityType?: string;
  action?: string;
  entityId?: string;
  actorId?: string;
  actorType?: string;
  outcome?: string;
  severity?: string[];
  runId?: string;
  entityDisplay?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private readonly apiUrlEvents = `${environment.loggingBaseUrl}/bernie-rdm/events`;

  private readonly apiUrlCatalog = `${environment.loggingBaseUrl}/bernie-rdm/catalog`;

  constructor(private http: HttpClient) {}

  getEvents(): Observable<AdminResDto> {
    const url = `${this.apiUrlEvents}`;

    return this.http.get<AdminResDto>(url).pipe(
      expand(response => {
        if (!response.continuationToken) {
          return EMPTY;
        }

        return this.http.get<AdminResDto>(url, {
          params: {
            continuationToken: response.continuationToken
          }
        });
      }),
      reduce(
        (result: AdminResDto, response: AdminResDto): AdminResDto => ({
          items: [
            ...result.items,
            ...response.items
          ],
          continuationToken: response.continuationToken
        })
      )
    );
  }

  getFilteredEvents(
  filters: FilterParams,
  ): Observable<AdminResDto> {
    const url = `${this.apiUrlEvents}`;

    let params = new HttpParams();

    if (filters.from)
      params = params.set('from', filters.from);

    if (filters.to)
      params = params.set('to', filters.to);

    if (filters.component)
      params = params.set('component', filters.component);

    if (filters.entityType)
      params = params.set('entityType', filters.entityType);

    if (filters.action)
      params = params.set('action', filters.action);

    if (filters.entityId)
      params = params.set('entityId', filters.entityId);

    if (filters.actorId)
      params = params.set('actorId', filters.actorId);

    if (filters.actorType)
      params = params.set('actorType', filters.actorType);

    if (filters.outcome)
      params = params.set('outcome', filters.outcome);

    if (filters.severity) {
      filters.severity.forEach(value => {
        params = params.append('severity', value);
      });
    }

    if (filters.runId)
      params = params.set('runId', filters.runId);

    if (filters.entityDisplay)
      params = params.set('entityDisplay', filters.entityDisplay);

    return this.http.get<AdminResDto>(url, { params }).pipe(
      expand(response => {
        if (!response.continuationToken) {
          return EMPTY;
        }

        const nextParams = params.set(
          'continuationToken',
          response.continuationToken
        );

        return this.http.get<AdminResDto>(url, {
          params: nextParams
        });
      }),

      reduce(
        (result, response): AdminResDto => ({
          items: [...result.items, ...response.items],
          continuationToken: response.continuationToken
        })
      )
    );
  }


  getCatalog(
  ): Observable<CatalogResDto> {
    const url = `${this.apiUrlCatalog}`;

    return this.http.get<CatalogResDto>(url);
  }
}